import { generatePath } from 'react-router-dom';

let navigator = null;

const ROUTES = {
	login: '/',
	userslist: '/admin/userslist',
	transaction: '/transactions/:id',
	transactions: '/transactions',
	deals_active: '/deals/active',
	deals_history: '/deals/history',
	transaction_currency: '/transaction-currency',
	accounts: '/accounts',
	clients: '/clients',
	client: '/client/:id',
};

export const setNavigator = (navFn) => {
	navigator = navFn;
};

export const navigateTo = (routeName, params = {}, options = {}) => {
	if (!navigator) {
		console.error('Navigator not initialized');
		return;
	}
	
	const path = ROUTES[routeName];
	if (!path) {
		console.error(`Route "${routeName}" not found`);
		return;
	}
	
	const fullPath = params && Object.keys(params).length > 0 
		? generatePath(path, params) 
		: path;

	navigator(fullPath, options);
};

export const goHome = (options = {}) => {
	if (!navigator) return;
	navigator('/', options);
};

export const goBack = () => {
	if (navigator) {
		navigator(-1);
	}
};

export const linkTo = (routeName, params = {}) => {
	const path = ROUTES[routeName];
	if (!path) {
		console.error(`Route "${routeName}" not found`);
		return '#';
	}
	
	return params && Object.keys(params).length > 0 
		? generatePath(path, params) 
		: path;
};

export const linkToWithQuery = (routeName, queryParams = {}) => {
	const path = ROUTES[routeName];
	if (!path) {
		console.error(`Route "${routeName}" not found`);
		return '#';
	}
	
	const query = new URLSearchParams(queryParams).toString();
	return query ? `${path}?${query}` : path;
};

export const customNavigate = (url, options = {}) => {
	if (!navigator) {
		console.error('Navigator not initialized');
		return;
	}
	navigator(url, options);
};